import React, { useState } from "react";
import { Tabs as Abas, Tab, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import styled from "styled-components";
import TabAriba from "./TabAriba";
import TabEmpresaAriba from "./TabEmpresa";
import TabCatalog from "./TabCatalog";

function TabsAriba({
	touched,
	values,
	errors,
	handleChange,
	onTestConnect,
	onTestConnectHana,
	connected,
	connectedHana,
	isLoading,
	isLoadingHana
}) {
	const [tabIndex, setTabIndex] = useState(0);
	return (
		<ModernContainer>
			<Abas selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
				<TabList>
					<Tab>Empresa</Tab>
					<Tab>Ariba</Tab>
					<Tab>Catalog</Tab>
				</TabList>
				<TabPanel>
					<TabEmpresaAriba
						touched={touched}
						values={values}
						errors={errors}
						handleChange={handleChange}
						onTestConnect={onTestConnect}
						onTestConnectHana={onTestConnectHana}
						connected={connected}
						connectedHana={connectedHana}
						isLoading={isLoading}
						isLoadingHana={isLoadingHana}
					/>
				</TabPanel>
				<TabPanel>
					<TabAriba
						touched={touched}
						values={values}
						errors={errors}
						handleChange={handleChange}
					/>
				</TabPanel>
				<TabPanel>
					<TabCatalog
						touched={touched}
						values={values}
						errors={errors}
						handleChange={handleChange}
					/>
				</TabPanel>
			</Abas>
		</ModernContainer>
	);
}

const ModernContainer = styled.div`
	width: 100%;
	font-family: 'Mulish', sans-serif;

	.react-tabs {
		-webkit-tap-highlight-color: transparent;
	}

	.react-tabs__tab-list {
		border-bottom: 2px solid #e2e8f0 !important;
		margin: 0 0 24px !important;
		padding: 0 !important;
		display: flex !important;
		gap: 8px !important;
		flex-wrap: wrap !important;
	}

	.react-tabs__tab {
		padding: 12px 24px !important;
		border: none !important;
		background: transparent !important;
		cursor: pointer !important;
		font-size: 14px !important;
		font-weight: 600 !important;
		color: #64748b !important;
		border-bottom: 3px solid transparent !important;
		transition: all 0.3s ease !important;
		font-family: 'Mulish', sans-serif !important;
		outline: none !important;
		list-style: none !important;
		position: relative !important;
		margin: 0 !important;

		&:hover {
			color: #667eea !important;
			background: rgba(102, 126, 234, 0.05) !important;
			border-radius: 8px 8px 0 0 !important;
		}
	}

	.react-tabs__tab--selected {
		color: #667eea !important;
		border-bottom-color: #667eea !important;
		background: rgba(102, 126, 234, 0.05) !important;
		border-radius: 8px 8px 0 0 !important;
	}

	.react-tabs__tab--disabled {
		color: #cbd5e1 !important;
		cursor: not-allowed !important;

		&:hover {
			color: #cbd5e1 !important;
			background: transparent !important;
		}
	}

	.react-tabs__tab:focus {
		box-shadow: none !important;
	}

	.react-tabs__tab-panel {
		display: none !important;
		animation: fadeIn 0.3s ease !important;
	}

	.react-tabs__tab-panel--selected {
		display: block !important;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

export default TabsAriba;
